import {
  CreateAdminCompanyFormData,
  CreateAdminCompanyRequestData,
} from '../types';
import { getCompanyTimezone } from './company-timezone';

export function buildFormData(): CreateAdminCompanyFormData {
  return {
    name: "",
    applicationId: "",
    timezone: getCompanyTimezone(),
    createMessageProfile: true,
    useCase: "",
    subUseCases: [],
    vertical: undefined,
    brandRelationship: undefined,
    phoneNumberType: undefined,
    phoneNumber: undefined,
  };
}

export function buildRequestData(data: CreateAdminCompanyFormData): CreateAdminCompanyRequestData {
  return {
    name: data.name,
    applicationId: data.applicationId,
    timezone: data.timezone,
    createMessageProfile: !!data.createMessageProfile,
  };
}
